import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const NULL_LEVEL2_GUID = '00000000-0000-0000-0000-000000000000';

const updateLevel2ApproverQuery = (payload) => {
  const raw = payload.level2Approver ?? '';
  const level2Approver = (typeof raw === 'string' && raw.trim() === '') || raw == null
    ? NULL_LEVEL2_GUID
    : String(raw).trim();
  const body = {
    purchaseOrderId: payload.purchaseOrderId,
    level2Approver
  };
  return axios.post(apiurl?.updateLevel2Approver, body);
};

const updateLevel2Approver = () => {
  const queryClient = useQueryClient();
  return useMutation(['updateLevel2Approver'], updateLevel2ApproverQuery, {
    onSuccess: (_, variables) => {
      const purchaseOrderId = variables?.purchaseOrderId;
      if (!purchaseOrderId) return;

      queryClient.invalidateQueries('getPO');
      queryClient.refetchQueries('getPO');
     // queryClient.invalidateQueries(['getPoApprovalFlowLog', purchaseOrderId]);
    }
  });
};

export default updateLevel2Approver;
